import { Theme } from '@mui/material'

// Toast共通のTypographyスタイル
export const toastTypographySx = {
  color: 'white',
  fontWeight: 500,
}

// MuiAlert共通設定
export const alertProps = {
  elevation: 6,
  variant: 'filled' as const,
}

// MuiAlert共通スタイル（type別）
export const getAlertSx = (
  theme: Theme,
  type: 'success' | 'error' | 'warning' | 'info'
) => ({
  backgroundColor: theme.palette.toast[type].background,
  border: `1px solid ${theme.palette.toast[type].border}`,
  '& .MuiAlert-icon': {
    color: 'white',
  },
})
